import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import Switch from 'flarum/common/components/Switch';
import ItemList from 'flarum/common/utils/ItemList';
export default function addPreferences() {
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    var _this$user;
    const composerItems = new ItemList();
    composerItems.add('useRichTextEditor', m(Switch, {
      state: (_this$user = this.user) == null || (_this$user = _this$user.preferences()) == null ? void 0 : _this$user.useRichTextEditor,
      onchange: value => {
        this.useRichTextEditorLoading = true;
        this.user.savePreferences({
          useRichTextEditor: value
        }).then(() => {
          this.useRichTextEditorLoading = false;
          m.redraw();
        });
      },
      loading: this.useRichTextEditorLoading
    }, app.translator.trans('fof-rich-text.forum.settings.use_rich_text_editor_label')));
    if (!app.forum.attribute('richTextForceCompactParagraphs')) {
      var _this$user2;
      composerItems.add('richTextCompactParagraphs', m(Switch, {
        state: (_this$user2 = this.user) == null || (_this$user2 = _this$user2.preferences()) == null ? void 0 : _this$user2.richTextCompactParagraphs,
        onchange: value => {
          this.richTextCompactParagraphsLoading = true;
          this.user.savePreferences({
            richTextCompactParagraphs: value
          }).then(() => {
            this.richTextCompactParagraphsLoading = false;
            m.redraw();
          });
        },
        loading: this.richTextCompactParagraphsLoading
      }, app.translator.trans('fof-rich-text.forum.settings.rich_text_compact_paragraphs_label')));
    }
    items.add('composer', m(FieldSet, {
      label: app.translator.trans('fof-rich-text.forum.settings.composer_heading'),
      className: "Settings-composer"
    }, composerItems.toArray()));
  });
}